var _g, _g2, _circle, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMoney(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter0_b_175_1438)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#FEE3F1"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_175_1438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.2856 15.0715V32.3572M28.2141 18.2144H22.3213C21.5919 18.2144 20.8925 18.5041 20.3767 19.0198C19.861 19.5356 19.5713 20.235 19.5713 20.9644C19.5713 21.6937 19.861 22.3932 20.3767 22.9089C20.8925 23.4247 21.5919 23.7144 22.3213 23.7144H26.2499C26.9792 23.7144 27.6787 24.0041 28.1944 24.5198C28.7101 25.0356 28.9999 25.735 28.9999 26.4644C28.9999 27.1937 28.7101 27.8932 28.1944 28.4089C27.6787 28.9247 26.9792 29.2144 26.2499 29.2144H19.5713",
    stroke: "#FB89C5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.2859,
    cy: 23.7143,
    r: 18.3054,
    stroke: "#FB89C5",
    strokeWidth: 1.675
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_175_1438",
    x: -4,
    y: -4,
    width: 56,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_175_1438"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_175_1438",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_175_1438"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.8571,
    height: 18.8571,
    fill: "white",
    transform: "translate(14.8569 14.2858)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMoney);
export default __webpack_public_path__ + "static/media/IconMoney.864f52654bba48409f766e7551c78250.svg";
export { ForwardRef as ReactComponent };